import { useParams } from "react-router-dom";
import { isTaskPaidShelfSpace } from "tm-shared/utils";

import { usePointSelector, useTaskSelector } from "@/hooks";
import NotFound from "@/pages/System/NotFound";

import PaidShelfSpacePage from "./PaidShelfSpacePage";

function PaidShelfSpace() {
    const { pointId = "", taskId = "" } = useParams();

    const currentTask = useTaskSelector(pointId, taskId);
    const currentPoint = usePointSelector(pointId);

    if (!currentTask || !currentPoint || !isTaskPaidShelfSpace(currentTask)) {
        return <NotFound />;
    }

    return <PaidShelfSpacePage point={currentPoint} task={currentTask} />;
}

export default PaidShelfSpace;
